import posthog from "posthog-js";

// PostHog configuration
const POSTHOG_KEY = "phc_g0NeTNwmDSILQc3uuURcjO6k3gbAtOwphNKgkefmObd";
const POSTHOG_HOST = "https://us.i.posthog.com";

let isInitialized = false;

export const initPostHog = () => {
  if (isInitialized || typeof window === "undefined") return;


  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    capture_pageview: true,
    capture_pageleave: true,
    autocapture: true,
    persistence: "localStorage",
    // Respect user privacy preferences
    opt_out_capturing_by_default: false,
    // Session recording (can be toggled)
    disable_session_recording: false,
    // Performance optimization
    loaded: (posthog) => {
      // Enable debug mode in development
      if (import.meta.env.DEV) {
        posthog.debug();
      }
    },
  });

  isInitialized = true;
};

export const identifyUser = (userId: string, properties?: Record<string, any>) => {
  if (!isInitialized) return;
  posthog.identify(userId, properties);
};

export const resetUser = () => {
  if (!isInitialized) return;
  posthog.reset();
};

export const captureEvent = (eventName: string, properties?: Record<string, any>) => {
  if (!isInitialized) {
    // Fallback logging when PostHog not initialized
    console.log("[Analytics]", eventName, properties);
    return;
  }
  posthog.capture(eventName, properties);
};

export const setUserProperties = (properties: Record<string, any>) => {
  if (!isInitialized) return;
  posthog.people.set(properties);
};

export { posthog };
